var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title" }, [
    _c(
      "div",
      {
        staticClass: "title-font",
        attrs: { text: "衡水市中小学基本情况统计" }
      },
      [_vm._v("\n    衡水市中小学基本情况统计\n  ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "update" }, [
      _c("span", [
        _vm._v(
          "最新监测时间：" + _vm._s(_vm._f("formatHourToSlash")(_vm.updateTime))
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "update-button", on: { click: _vm.updateData } },
        [_vm._v("更新数据")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-be90cd62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-be90cd62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/big-screen/ScreenHeader.vue
// module id = null
// module chunks = 